import React, { useState } from "react";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Login failed");
        return;
      }
      try {
        const params = new URLSearchParams(window.location.search);
        const next = params.get("next");
        if (next && /^https:\/\/[a-z0-9.-]+\.eim\.digital(\/|$)/.test(next)) {
          window.location.replace(next);
          return;
        }
      } catch {}
      onLogin(data.user);
    } catch {
      setError("Connection failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="eim-login-shell">
      <div className="eim-login-card">
        <h1>EIM <span className="eim-accent">·</span> Truck</h1>
        <div className="eim-login-tag">Fleet · Vehicle Monitor</div>

        <form onSubmit={handleSubmit}>
          <div className="eim-field">
            <label>Email</label>
            <input
              className="eim-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@energyinmotion.in"
              required
              autoFocus
              autoComplete="username"
            />
          </div>
          <div className="eim-field">
            <label>Password</label>
            <input
              className="eim-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>

          {error && <div className="eim-banner-err">{error}</div>}

          <button type="submit" className="eim-btn-primary" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
